<template>
  <div class="ct-form-rows tecal-grid tecal-grid-compact">
    <div
      v-for="(correct, idx) in tecalCorrect"
      :key="idx"
      class="ct-tecal-card tecal-card-compact"
      :class="{
        'has-value': answers[idx] > 0,
        'is-corrected': corrected,
      }"
    >
      <div class="ct-tecal-main tecal-main-compact">
        <div class="ct-num">{{ idx + 1 }}</div>
        <div class="ct-tecal-q">Ítem {{ idx + 1 }}</div>
        <div class="ct-choice-row">
          <button
            v-for="v in 3"
            :key="v"
            type="button"
            class="ct-choice"
            :class="{
              active: answers[idx] === v,
              'ct-guide-blink': idx === 0 && isGuideActive(1),
            }"
            @click="setAnswer(idx, v)"
          >
            {{ v }}
          </button>
        </div>
        <div
          v-if="corrected"
          class="ct-tecal-result-inline"
          :class="{ empty: !answers[idx] }"
        >
          <template v-if="answers[idx]">
            <span>C:{{ correct }}</span>
            <span
              class="ct-result-pill"
              :class="answers[idx] === correct ? 'ok' : 'bad'"
            >
              {{ answers[idx] === correct ? "✓" : "×" }}
            </span>
          </template>
          <template v-else>
            <span>S/R</span>
            <span class="ct-result-pill empty">—</span>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { TECAL_CORRECT } from "../data/tecalCorrect";
import { submitCorrection, createCorrectionPayload } from "@/services/testCorrectionAdapter";

export default {
  name: "TecalForm",
  inject: {
    corregirTestWorkspace: { default: null },
  },
  props: {
    testValue: { type: Number, required: true },
    age: { type: String, default: "" },
    initialAnswers: { type: Object, default: null },
  },
  data() {
    return {
      tecalCorrect: TECAL_CORRECT,
      answers: Array(101).fill(0),
      corrected: false,
      loading: false,
      fieldGuideDismissed: false,
    };
  },
  created() {
    this.hydrate(this.initialAnswers);
  },
  computed: {
    toolbarLabel() {
      return "Corregir test";
    },
    toolbarDisabled() {
      if (this.loading || this.corrected) return true;
      return !this.age;
    },
  },
  watch: {
    toolbarLabel: { immediate: true, handler: "emitToolbarMeta" },
    toolbarDisabled: { immediate: true, handler: "emitToolbarMeta" },
    loading: { handler: "emitToolbarMeta" },
    age() {
      this.fieldGuideDismissed = false;
    },
  },
  methods: {
    emitToolbarMeta() {
      this.$emit("toolbar-meta", {
        label: this.toolbarLabel,
        disabled: this.toolbarDisabled,
        loading: this.loading,
      });
    },
    setAnswer(idx, value) {
      const next = this.answers[idx] === value ? 0 : value;
      this.$set(this.answers, idx, next);
      this.corrected = false;
      this.fieldGuideDismissed = true;
      this.tryGuideAdvance();
    },
    isGuideActive(id) {
      if (this.fieldGuideDismissed) return false;
      const ws = this.corregirTestWorkspace;
      return ws && ws.isFieldGuideActive(id);
    },
    tryGuideAdvance() {
      const ws = this.corregirTestWorkspace;
      if (ws && ws.dismissFieldGuide) ws.dismissFieldGuide();
    },
    buildPayload() {
      const answers = { edad: this.age };
      this.tecalCorrect.forEach((correct, idx) => {
        const key = `p${idx + 1}`;
        const val = this.answers[idx];
        answers[key] = val ? String(val) : String(correct);
      });
      return answers;
    },
    // Inversa de buildPayload, con una pérdida conocida: los ítems que quedaron
    // sin marcar se enviaron con la alternativa correcta (es la convención del
    // protocolo — no marcar = respondió bien), así que al editar aparecen todos
    // marcados y ya no se distingue cuáles el profesional dejó en blanco. No
    // cambia el resultado: reenviar lo hidratado produce el mismo puntaje.
    hydrate(stored) {
      if (!stored) return;
      this.tecalCorrect.forEach((correct, idx) => {
        const raw = stored[`p${idx + 1}`];
        if (raw == null || raw === "") return;
        const num = Number(raw);
        if (!Number.isNaN(num)) this.$set(this.answers, idx, num);
      });
      this.fieldGuideDismissed = true;
    },
    async submit() {
      if (this.toolbarDisabled) return;
      this.loading = true;
      try {
        const data = await submitCorrection(
          createCorrectionPayload({
            testValue: this.testValue,
            answers: this.buildPayload(),
          })
        );
        this.corrected = true;
        this.$emit("corrected", data);
      } catch (err) {
        const msg =
          (err && err.message) ||
          "No se pudo corregir TECAL. Revisa los datos.";
        if (this.$toasted) this.$toasted.error(msg);
      } finally {
        this.loading = false;
      }
    },
    reset() {
      this.answers = Array(101).fill(0);
      this.corrected = false;
      this.loading = false;
      this.fieldGuideDismissed = false;
    },
  },
};
</script>
